import { useQuery } from 'react-query';
import { useAccessToken } from 'utils/auth';
import { fetchAssignmentDetails } from './api';
import { USE_ASSIGNMENT_DETAILS_QUERY_KEY } from './constants';

export const useAssignmentDetailsQuery = (assignmentId: string | undefined) => {
  const { token } = useAccessToken();

  return useQuery(
    [USE_ASSIGNMENT_DETAILS_QUERY_KEY, assignmentId],
    () => fetchAssignmentDetails(token, assignmentId),
    {
      enabled: !!(token && assignmentId)
    }
  );
};
